var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"disabled":_vm.disabled,"icon":_vm.icon,"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t(_vm.buttonText)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }